// Centralised site config - edit these to update the whole site
export const SITE = {
    name: "MZ Trading Lab",
    short: "MTL",
    logoUrl: "/mtl-logo.jpg",
    // Telegram channel/group invite link
    telegram: "https://t.me/mztradinglab",
    tagline: "Trade smarter with MY & SG's most supportive trading lab.",
};

export const TELEGRAM_URL = SITE.telegram;
